import React, { useEffect, useState } from 'react'
import {Trans, useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import {CaseForms, UserRoleEnum} from '../../../../helpers/enums'
import {SwitchUser} from '../../../../helpers/helpers';
import CaseGenerator from '../../../CaseGenerator/CaseGenerator'
import digitalizzazioneCustomModalSuccess
  from '../../../CaseGenerator/custom-success-modal/digitalizzazioneCustomModalSuccess'; 
import { GET_BANK_DOMICILIATION } from '../../../../helpers/queries';
import { client } from '../../../../App';
import { hideLoading, showLoading } from '../../../../reducers/app';
import { useHistory } from 'react-router';
import Modal from '../../../common/Modal/Modal';


const ModificaDomiciliazioneBancariaComplexCase = () => {
  const dispatch = useDispatch();
  const [currentBankDomiciliationData, setCurrentBankDomiciliationData] = useState();
  const auth = useSelector((state) => state.auth);
  const selectedContract = useSelector((state) => state.contracts.current);
  const {user} = auth;
  const userProfile = SwitchUser(auth);
  const role = userProfile ? userProfile.role : null;
  const {t} = useTranslation();
  const blockForm = userProfile &&
    userProfile.isCondominiumAdminDisabled && role === UserRoleEnum.CONDOMINIUM_ADMIN;
  const [showPopup, setShowPopup] = useState(false);
  const history = useHistory();
  const [missingOwnerData, setMissingOwnerData] = useState(false);
  const [goToBankDataStep, setGoToBankDataStep] = useState(false);

  useEffect(() => {
    dispatch(showLoading());
    const currentBankDomiciliation = async () => client().query({
      query: GET_BANK_DOMICILIATION,
      variables: {
        req: {
          contractId: selectedContract.id
        }
      }
    });
    currentBankDomiciliation()
    .then(({ data }) => {
      const currentBankDomiciliationMapping = {
            email: data.retrieveBankDomiciliation.accountHolder.contactsInfo.email,
            phoneNumber: data.retrieveBankDomiciliation.accountHolder.contactsInfo.phoneNumber,
            IBAN: data.retrieveBankDomiciliation.bankData.IBAN,
            bankName: data.retrieveBankDomiciliation.bankData.bankName,
            branchName: data.retrieveBankDomiciliation.bankData.branchName,
            businessName: data.retrieveBankDomiciliation.bankProfile.businessName,
            fiscalCode: data.retrieveBankDomiciliation.bankProfile.fiscalCode,
            bankPhoneNumber: data.retrieveBankDomiciliation.bankProfile.phoneNumber,
            address: data.retrieveBankDomiciliation.bankProfile.address,
            bankEmail: data.retrieveBankDomiciliation.bankProfile.email,
      }
      setCurrentBankDomiciliationData(currentBankDomiciliationMapping);
      if(!(currentBankDomiciliationMapping.businessName && currentBankDomiciliationMapping.fiscalCode && currentBankDomiciliationMapping.bankPhoneNumber && currentBankDomiciliationMapping.address && currentBankDomiciliationMapping.bankEmail)){
        setMissingOwnerData(true);
      }
      dispatch(hideLoading());
    }).catch(()=>{
      setShowPopup(true);
      }
    );
  }, []);

  return (
    <>
      <Modal
        show={showPopup}
        onClose={() => history.push("/")}
        type={"link"}
        to={"/"}
        linkTitle={t("common.goToDashboard")}
        description={t('cases.generic_error')}
      />
      <Modal
        show={missingOwnerData}
        onClose={() => setMissingOwnerData(false)}
        type={"button"}
        linkTitle={t("common.close")}
        onFirstClick={() => setMissingOwnerData(false)}
        description={
          <Trans
            values={{ctaLabel: t("modal.button.missingOwnerData.serviceBankDomiciliation.modification")}}
            i18nKey={"modal.missingOwnerData.serviceBankDomiciliation.modification"}
            components={[<a className="link-a" href="#" onClick={(e) => {
              e.preventDefault();
              setGoToBankDataStep(true);
              setMissingOwnerData(false);}} target="_self"/>]}
            parent=""
          />
        }
      />
        <div className="DomiciliazioneBancariaComplexCase" data-testid="DomiciliazioneBancariaComplexCase">
        {currentBankDomiciliationData && <CaseGenerator
          type={CaseForms.ModificaDomiciliazioneBancariaComplex}
          block={blockForm}
          signDigital={user && user.role !== 'MUNICIPAL_OPERATOR' ? true : false}
          successModalCustom={
            (props) => digitalizzazioneCustomModalSuccess({t: t, content: "cases.digitalization.success", ...props})
          }
          excludeSteps={user && user.role === 'MUNICIPAL_OPERATOR' ? [9] : []}
          blockText={blockForm && t("associate-contract.block-view")}
          initialValues={{
            selezioneContratto: selectedContract.id || "",
            comune: selectedContract.city || "", 
            via: `${selectedContract.street || ""}, ${selectedContract.streetNumber || ""}`,  
            nominativo: selectedContract.accountHolder?.businessName || "",
            integraClientCode: selectedContract.clientCode || "",
            fiscalCode: selectedContract.accountHolder?.fiscalCode || "",
            vatNumber: selectedContract.accountHolder?.vatNumber || "",
            address: `${selectedContract.accountHolder?.address?.street || ""} ${selectedContract.accountHolder?.address?.streetNumber || ""} ${selectedContract.accountHolder?.address?.city || ""}`,
            signValue: user && user.role !== 'MUNICIPAL_OPERATOR',
            telefono: currentBankDomiciliationData?.phoneNumber || "",
            email : currentBankDomiciliationData?.email || "", 
            userNominativo : currentBankDomiciliationData?.businessName || "", 
            userFiscalCode : currentBankDomiciliationData?.fiscalCode || "", 
            userAddress: currentBankDomiciliationData?.address || "", 
            userTelefono : currentBankDomiciliationData?.bankPhoneNumber || "",
            confirmEmail: currentBankDomiciliationData?.bankEmail || "",
            userEmail : currentBankDomiciliationData?.bankEmail || "",
            bankName : currentBankDomiciliationData?.bankName || "",
            agencia : currentBankDomiciliationData?.branchName || "",
            iban : currentBankDomiciliationData?.IBAN || ""}}
            currentStep={goToBankDataStep ? 0 : null}
        />
        }
      </div>
    </>
  )
}

export default ModificaDomiciliazioneBancariaComplexCase
